import React from 'react';

const JS_Booleans = () => {
  return (
    <div >
      <h1>JS_Booleans</h1>
      <p>Placeholder component for: "JS Booleans"</p>
    </div>
  );
};

export default JS_Booleans;
